<template><article><h1>Disorderly slider</h1>
<p>By default, the sliders are ordered.</p>
<p>The slider can be made unordered by setting <code v-pre>order = false</code>. This is very useful when you need to distinguish the effects of multiple sliders.</p>
<div class="warning custom-block"><p class="custom-block-title">WARNING</p>
<p>When the value of <code v-pre>order</code> is <code v-pre>false</code>, the parameter &lt;<code v-pre>minRange</code>|<code v-pre>maxRange</code>|<code v-pre>enableCross</code>|<code v-pre>fixed</code>&gt; is invalid.</p>
</div>
<h3 id="usage"><a class="header-anchor" href="#usage" aria-hidden="true">#</a> Usage</h3>
<p><example :value="example1"></example></p>
<h3 id="independent-slider"><a class="header-anchor" href="#independent-slider" aria-hidden="true">#</a> Independent slider</h3>
<p><example :value="example2"></example></p>
<div class="tip custom-block"><p class="custom-block-title">TIP</p>
<p><code v-pre>v-slot:</code> (Symbol <code v-pre>#</code>) can only be used above <code v-pre>vue</code> version 2.6.0, otherwise use <code v-pre>slot</code> and <code v-pre>slot-scope</code>.</p>
<p>See also <a href="https://vuejs.org/v2/guide/components-slots.html#Named-Slots-Shorthand">Official Document</a></p>
</div>
</article></template>

<script>
  import examples from '@/examples/order.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>